import React from 'react'
import PropTypes from 'prop-types'
import { XClose } from '@untitled-ui/icons-react'

const TONES = {
  info: 'border-gray/300 bg-gray/50 text-gray-800',
  warning: 'border-warning/300 bg-warning/50 text-warning/800',
  error: 'border-error/300 bg-error/50 text-error/800',
  success: 'border-success/300 bg-success/50 text-success/800',
}

/** Inline banner: a title, optional body, optional dismiss. Errors are announced as alerts. */
export default function Notice({ tone = 'warning', title, children, onDismiss }) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={`relative flex flex-col gap-1 rounded-lg border px-4 py-3 text-sm ${TONES[tone]}`}
    >
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="absolute right-2 top-2 rounded p-1 opacity-70 hover:opacity-100"
        >
          <XClose className="size-4" stroke="currentColor" />
        </button>
      )}
      {title && <p className="pr-6 font-semibold">{title}</p>}
      {children}
    </div>
  )
}

Notice.propTypes = {
  tone: PropTypes.oneOf(Object.keys(TONES)),
  title: PropTypes.node,
  children: PropTypes.node,
  onDismiss: PropTypes.func,
}
